export interface SolidArrowProps {
  width?: string;
  height?: string;
  className?: string;
}

function SolidArrowIcon({ width = '10', height = '8', className, ...rest }: SolidArrowProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 10 8'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
      className={className}
    >
      <path d='M5 8L9.33013 0.5L0.669873 0.5L5 8Z' fill='#F16622' />
    </svg>
  );
}

export default SolidArrowIcon;
